import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/styles';
import {
    deleteMasterApp,
    getMasterApps,
    resetDagState,
} from '../../../../redux/actions/dagActions';
import { logoutUser } from '../../../../redux/actions/authActions';
import { Theme } from '../../../../utils/Theme';
import Header from '../../../layout/Partials/Header';
import { Link, withRouter } from 'react-router-dom';
import AccessDenied from '../../../common/AccessDenied';
import Loading from '../../../common/Loading';
import Error from '../../../common/Error';
import AdminLayout from '../../../layout/AdminLayout';
import moment from 'moment';
import * as Icon from 'react-feather';
import DataTable from 'react-data-table-component';
import { dagResync } from '../../../common/Notfications';
import { Helmet } from 'react-helmet';

const styles = Theme();

class MasterApps extends Component {
    constructor(props) {
        super(props);
        this.state = {
            masterApps: {},
            toDelete: null,
            loading: true,
            errors: {},
        };

        this.columns = [
            {
                name: 'Title',
                selector: 'title',
                sortable: true,
            },
            {
                name: 'Created',
                sortable: false,
                cell: (masterApp) => (
                    <span>{moment(masterApp.date).format('Do MMMM YYYY')}</span>
                ),
            },
            {
                name: 'Actions',
                sortable: false,
                cell: (row) => this.tableActions(row),
            },
        ];
        this.deleteMasterApp = this.deleteMasterApp.bind(this);
    }

    tableActions = (masterApp) => (
        <div>
            <button
                onClick={() =>
                    this.props.history.push(
                        `/settings/dag/master-apps/${masterApp._id}/view`
                    )
                }
                className={`c-btn ${this.props.classes.buttonPrimary} u-m-xsmall c-btn--small has-arrow u-text-center`}
            >
                <Icon.Eye size={10} /> View
            </button>

            {/*TODO : RESOLVE EDIT DELETE FUNCTION*/}
            <button
                onClick={() =>
                    this.props.history.push(
                        `/settings/dag/master-apps/${masterApp._id}/edit`
                    )
                }
                className={`c-btn ${this.props.classes.buttonInfo} u-m-xsmall c-btn--small has-arrow u-text-center`}
            >
                <Icon.Edit3 size={10} /> Edit
            </button>

            <button
                onClick={() => this.setState({ toDelete: masterApp._id })}
                className={`c-btn ${this.props.classes.buttonDanger} u-m-xsmall c-btn--small has-arrow u-text-center`}
            >
                <Icon.Slash size={10} /> Delete
            </button>
        </div>
    );

    componentDidMount() {
        this.props.getMasterApps();
    }

    componentWillUnmount() {
        this.props.resetDagState();
    }

    deleteMasterApp() {
        this.props.deleteMasterApp(this.state.toDelete);
    }

    render() {
        const { classes, auth, history, dag } = this.props;
        const { toDelete } = this.state;
        return (
            <AdminLayout>
                <Helmet>
                    <title>Master Apps</title>
                </Helmet>
                <div className="o-page">
                    <Header>
                        <h2 className="c-navbar__title">Master Applications</h2>
                    </Header>
                    {!auth.isAuthenticated || auth.user.role !== 'Admin' ? (
                        <AccessDenied props={{ classes, history }} />
                    ) : dag.loading === true ||
                      dag.masterApps === null ||
                      dag.masterApps === undefined ? (
                        <Loading />
                    ) : (
                        <div className="u-m-xsmall">
                            <div className={'row'}>
                                {dagResync(classes)}
                                <div className="col-md-12 col-sm-12 col-xl-12 u-mb-medium">
                                    <div className="u-m-auto">
                                        <div className="c-card u-p-zero u-m-zero">
                                            <div className="o-line c-card__title u-p-small u-m-small">
                                                <h4
                                                    className={`c-card__title ${classes.colorSecondary}`}
                                                >
                                                    Master Applications
                                                </h4>
                                                <div className="c-dropdown dropdown">
                                                    <span
                                                        className={`c-btn ${classes.buttonPrimary} has-icon dropdown-toggle`}
                                                        id="MoreActionsDropdown"
                                                        data-toggle="dropdown"
                                                        aria-haspopup="true"
                                                        aria-expanded="false"
                                                    >
                                                        More Actions
                                                    </span>

                                                    <div
                                                        className="c-dropdown__menu dropdown-menu has-arrow dropdown-menu-right"
                                                        aria-labelledby="MoreActionsDropdown"
                                                    >
                                                        <span
                                                            onClick={() => {
                                                                history.goBack();
                                                            }}
                                                            className="c-dropdown__item dropdown-item"
                                                        >
                                                            Back
                                                        </span>
                                                        <Link
                                                            to={`/settings/dag/master-apps/create`}
                                                            className="c-dropdown__item dropdown-item"
                                                        >
                                                            New Master App
                                                        </Link>
                                                        <Link
                                                            to={`/settings/pages`}
                                                            className="c-dropdown__item dropdown-item"
                                                        >
                                                            Pages
                                                        </Link>
                                                        <Link
                                                            to={`/settings/dag/filters`}
                                                            className="c-dropdown__item dropdown-item"
                                                        >
                                                            Filters
                                                        </Link>
                                                        <Link
                                                            to={`/settings/dag/dynamic-apps`}
                                                            className="c-dropdown__item dropdown-item"
                                                        >
                                                            Dynamic Apps
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                            {dag.masterApps.length > 0 ? (
                                                <div className="c-table-responsive@tablet">
                                                    {toDelete !== null ? (
                                                        <table className="c-table">
                                                            <thead className="c-table__head">
                                                                <tr className="c-table__row">
                                                                    <th className="c-table__cell c-table__cell--head">
                                                                        {toDelete ===
                                                                        null
                                                                            ? 'Title'
                                                                            : ''}
                                                                    </th>
                                                                    <th className="c-table__cell c-table__cell--head">
                                                                        {toDelete ===
                                                                        null
                                                                            ? 'Created'
                                                                            : ''}
                                                                    </th>
                                                                    <th className="c-table__cell c-table__cell--head u-text-right">
                                                                        Actions
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr className="c-table__row">
                                                                    <td
                                                                        colSpan={
                                                                            2
                                                                        }
                                                                        className="c-table__cell"
                                                                    >
                                                                        Deleting
                                                                        a master
                                                                        app will
                                                                        delete
                                                                        all
                                                                        associated
                                                                        dynamic
                                                                        apps
                                                                        from
                                                                        your
                                                                        site and
                                                                        the from
                                                                        Qlik
                                                                        Sense
                                                                        Server.
                                                                    </td>
                                                                    <td className="c-table__cell u-text-right">
                                                                        <button
                                                                            onClick={() =>
                                                                                this.setState(
                                                                                    {
                                                                                        toDelete: null,
                                                                                    }
                                                                                )
                                                                            }
                                                                            className={`c-btn ${classes.buttonSecondary} u-m-xsmall c-btn--small has-arrow u-text-center`}
                                                                        >
                                                                            <Icon.X
                                                                                size={
                                                                                    10
                                                                                }
                                                                            />{' '}
                                                                            Cancel
                                                                        </button>

                                                                        <button
                                                                            onClick={
                                                                                this
                                                                                    .deleteMasterApp
                                                                            }
                                                                            className={`c-btn ${classes.buttonDanger} u-m-xsmall c-btn--small has-arrow u-text-center`}
                                                                        >
                                                                            <Icon.Slash
                                                                                size={
                                                                                    10
                                                                                }
                                                                            />{' '}
                                                                            Confirm
                                                                            Delete
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    ) : (
                                                        <DataTable
                                                            title={''}
                                                            noHeader={true}
                                                            defaultSortField={
                                                                'title'
                                                            }
                                                            pagination
                                                            keyField={'_id'}
                                                            className={
                                                                'c-table'
                                                            }
                                                            columns={
                                                                this.columns
                                                            }
                                                            data={
                                                                dag.masterApps
                                                            }
                                                        />
                                                    )}
                                                </div>
                                            ) : (
                                                <Error
                                                    error={'Nothing to show!'}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </AdminLayout>
        );
    }
}

MasterApps.propTypes = {
    logoutUser: PropTypes.func.isRequired,
    getMasterApps: PropTypes.func.isRequired,
    deleteMasterApp: PropTypes.func,
    resetDagState: PropTypes.func,
    auth: PropTypes.object.isRequired,

    classes: PropTypes.object,
    history: PropTypes.object,
    qlik: PropTypes.object,
    dag: PropTypes.object,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    dag: state.dag,
});

export default connect(mapStateToProps, {
    logoutUser,
    resetDagState,
    getMasterApps,
    deleteMasterApp,
})(withStyles(styles)(withRouter(MasterApps)));
